import * as React from 'react';
import ProfileView from './Profile.component';
import { database, auth } from '../../firebase';
import { connect } from 'react-redux';
import { updateUser } from '../auth/AuthOperations'


const usersRef = database.ref('users');

class Profile extends React.Component{
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      saving: false,
      saved: false,
      resetPasswordEmailSent: false
    }
  }
  handleSubmit(values) {
    const { id, displayName , email, phone , role} = values;
    const updatedValues = {
      displayName: displayName || '',
      email: email || '',
      phone: phone || '',
      role: role || ''
    }
    const { auth } = this.props;
    this.setState({saving: true, saved: false});
    usersRef.child(auth.uid)
    .update(updatedValues).then(
      () => { 
        this.setState({saving:false, saved: true})
        this.props.updateUser(updatedValues)
      }
    )
  }
  resetPassword = (emailAddress) => {
    auth.sendPasswordResetEmail(emailAddress).then(() => {
      this.setState({resetPasswordEmailSent: true})
    }).catch(function(error) {
      // An error happened.
    });
  }
  render(){
    const { saving, saved, resetPasswordEmailSent } = this.state;
    return(
      <ProfileView
      onSubmit={this.handleSubmit}
      resetPassword={this.resetPassword}
      saving={saving}
      saved={saved}
      resetPasswordEmailSent={resetPasswordEmailSent}
      />
    )
  }
}
const mapStateToProps: any = ({ auth}) => {
  return {auth}
}
const mapDispatchToProps = (dispatch) => ({
  updateUser: (user) => dispatch(updateUser(user))
})
export default connect(mapStateToProps, mapDispatchToProps)(Profile);